/**
 * ng-expertiza.ru
 * Modal windows
 *
 * @author      delphinpro <delphinpro@gmail.com>
 * @copyright   copyright © 2018 delphinpro
 * @license     licensed under the MIT license
 */



const $modalsContainer = $('#forms');
const $body            = $('body');

$modalsContainer.on('click', '.modals-close', function() {
    $modalsContainer.find('.modal').removeClass('modal_show');
    $modalsContainer.removeClass('modals_show');
    $body.removeClass('lock');
});

const Modal = {
    show($modal) {
        $modalsContainer.addClass('modals_show');
        $body.addClass('lock');
        $modal.addClass('modal_show');

        $modal.data('vm').$emit('show.dpr.modal');
    },
};

$.fn.modal = function(cfg = {}) {
    if (typeof cfg === 'string') {
        if (Modal.hasOwnProperty(cfg)) {
            $.each(this, function() {
                Modal[cfg]($(this));
            });
        }
    } else {
        $.each(this, function() {
            let $modal = $(this.dataset.target);
            $(this).on('click', () => {
                Modal.show($modal);
            });
        });
    }
};
